import { useState } from "react";
import { useTranslation } from "react-i18next";
import { twMerge } from "tailwind-merge";
import { Alert, AlertType } from "@/atoms-react/alert/index.react";
import { Button } from "@/atoms-react/button/Button.react";
import InputLabel from "@/atoms-react/input/Input.react";
import { Base, InfoAlert, Label, SectionTitle } from "@/atoms-react/text/Text.react";
import { Themes } from "@/types/theme";
import { RepresentativeItem } from "..";

export type SendRepresentativeModalInfos = {
  isOpen: boolean;
  link: RepresentativeItem;
};

type SendRepresentativeInvitationProps = {
  handleSendInvite: (email?: string) => void;
  loading: boolean;
  infos: SendRepresentativeModalInfos;
};

export const SendRepresentativeInvitation = ({
  handleSendInvite,
  loading,
  infos
}: SendRepresentativeInvitationProps) => {
  const labelInputDivClassName = "md:flex items-center md:space-x-6";
  const labelClassName = "flex ml-2 md:mb-0 w-1/2";
  const inputClassName = "flex grow  w-full";
  const providedEmail = infos.link.mail ?? "";

  const [email, setEmail] = useState<string>();
  const { t } = useTranslation(["pass"]);

  return (
    <div className="p-6">
      <div className="flex w-full flex-row justify-center p-4">
        <SectionTitle>{t("business_links.invite_to_olkypass.title")}</SectionTitle>
      </div>
      <div className="flex w-full flex-row justify-center p-4">
        <div>
          <Base className="text-base">
            {t("business_links.invite_to_olkypass.description_1")}
            <span className="font-bold">{infos.link.name} </span>
            {t("business_links.invite_to_olkypass.description_2")}
          </Base>
        </div>
      </div>

      {!providedEmail && (
        <div className="flex w-full flex-row justify-center">
          <div className={twMerge(labelInputDivClassName, "mt-2")}>
            <Label className={labelClassName}>
              {t("business_links.invite_to_olkypass.input_label")} {infos.link.name}
            </Label>
            <div className={inputClassName}>
              <InputLabel
                required={true}
                className="w-full"
                placeholder="E-mail"
                type="email"
                value={email}
                onChange={(value) => {
                  setEmail(value);
                }}
              />
            </div>
          </div>
        </div>
      )}

      <div className="mb-8 flex w-full flex-row justify-center">
        <Button
          size="md"
          theme={Themes.success}
          loading={loading}
          disabled={!email && !providedEmail}
          onClick={() => {
            if (providedEmail) handleSendInvite();
            else if (email) handleSendInvite(email);
          }}
          className="mt-4 w-1/4 rounded-lg"
        >
          {t("business_links.invite_to_olkypass.button")}
        </Button>
      </div>
      <Alert className="py-6" type={AlertType.Info} title={"Information"}>
        <div>
          <InfoAlert className="mt-2 block text-base">
            {t("business_links.invite_to_olkypass.info_alert")}
            <span className="font-bold">{infos.link.name} </span>
            {t("business_links.invite_to_olkypass.info_alert_part2")}
          </InfoAlert>
        </div>
      </Alert>
    </div>
  );
};
